<template>
  <div :class="$style.app__loader">
    <img :class="$style.loader__spinner" src="/static/loader__spinner.svg">
  </div>
</template>

<script>
  export default {
    name: 'app-loader'
  }
</script>

<style lang="stylus" module>
  .app__loader
    position relative
    width 100%
    height 100%
    background-color transparent

  .loader__spinner
    display block
    width 12.5%
    height auto
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
</style>


// WEBPACK FOOTER //
// AppLoader.vue?0570b5d3